export default __webpack_public_path__ + "static/media/residency stay intern.6ef42a57.jpg";